<template>
  <div class="popup-wraper" @click="onHideModal">
    <div class="overlay" @click.stop>
      <div class="scroll">
        <div class="container">
          <div class="title">delete {{ tab }}?</div>
          <div class="delete-list">
            <div
              class="delete-item"
              v-for="(i, idx) of checkedItems"
              :key="idx"
            >
              {{ getItemName(i) }}
            </div>
          </div>
        </div>
        <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
        <button
          :data-is-avalable="popupsVisible"
          id="apply-btn"
          class="popup-btn"
          ref="deleteBtn"
          @click="onDeleteItems"
        >
          apply
        </button>
        <div class="close" @click="onHideModal">&times;</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "deletePopup",
  data() {
    return {
      errorMsg: ""
    };
  },
  computed: {
    ...mapGetters({
      checkedItems: "catalog/checkedItems",
      popupsData: "workSpace/popupsData",
      popupsVisible: "workSpace/popupsVisible"
    }),
    tab() {
      return this.popupsData.step;
    }
  },
  mounted() {},
  methods: {
    async onDeleteItems() {
      try {
        this.$refs.deleteBtn.disabled = true;
        await this.$store.dispatch("contributions/deleteContentItems", {
          items: this.checkedItems,
          type: this.tab
        });
        this.$refs.deleteBtn.disabled = false;
        this.$store.commit("catalog/updateCheckedItems");
        this.onHideModal();
      } catch (error) {
        this.showError(error);
        this.$refs.deleteBtn.disabled = false;
      }
    },
    getItemName(i) {
      if (this.tab === "users") return i.name;
      if (this.tab === "feedbacks")
        return `${this.getCorrectDate(i.created_at)}: ${i.user_email}`;
      return i.name;
    },
    getCorrectDate(date) {
      return new Date(Date.parse(date)).toString().slice(4, 21);
    },
    onHideModal() {
      this.$emit("hide-modal");
    },
    showError(msg = "") {
      this.errorMsg = msg;
    }
  }
};
</script>

<style scoped>
.popup-wraper {
  position: fixed;
  background: rgba(188, 188, 203, 0.8);
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 998;
  cursor: default;
}
.overlay {
  position: fixed;
  background: #fff;
  max-width: 1330px;
  width: calc(100% - 100px);
  max-height: 668px;
  height: calc(100vh - 100px);
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.scroll {
  overflow: auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.close {
  position: absolute;
  right: 10px;
  top: 6px;
  color: #1d2d36;
  font-size: 24px;
  line-height: 24px;
  cursor: pointer;
}
.container {
  width: 100%;
  height: 100%;
  height: calc(100% - 75px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.delete-list {
  height: calc(100%);
  width: calc(100% - 20px);
  overflow: auto;
  text-align: center;
}
.title {
  margin: 15px;
  font-size: 16px;
  font-weight: 600;
}

.error {
  color: red;
}
</style>
